<app-checkout-page
  [sectionTitle]="productSpecificCustomRouteData.pageTitle"
  [subtitle]="productSpecificCustomRouteData.pageSubtitle"
  [emojis]="emojis"
  [allMilestones]="productSpecificCustomRouteData.funnelHeaderMilestones"
  [infoDialog]="infoDialog"
  (navigateBack)="onNavigateBack()"
  (navigateNext)="onNavigateNext()"
  (formSubmit)="onInternalFormSubmit($event)"
  (formChange)="onFormChange($event)"
  [consultationAppointmentUrl]="consultationAppointmentUrl"
  [data]="data$ | async"
  [formConfiguration]="formConfiguration"
  [enableBackButton]="enableBackButton"
  [enableSkipButton]="enableSkipButton"
>
</app-checkout-page>
